<script>
	import { uiText } from "../lib/uiText.js";
	import { createEventDispatcher } from "svelte";
	import { slide } from "svelte/transition";
	import Qr from "./QR.svelte";
	const dispatch = createEventDispatcher();
	export let lang = "bg";
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));
	export let pastAnswers = [];
	export let riddle;
	// console.log(riddle);
	let progbar = riddle.progbar;
	let type = riddle.type || "single"; //qr, qr-mc (multiple valid, single needed), qr-multiple (scan multiple codes), qr-unlock
	let answers = riddle.answers;
	let input = "";
	let wrongAnswers = [];

	let qr_state = false;
	$: qr_state, document.body.classList[qr_state ? "add" : "remove"]("noscroll");

	const inActive = [];
	const inPast = [];

	// console.log(pastAnswers);
	// console.log(Object.keys(pastAnswers));
	// console.log(Object.keys(answers));
	let pastAnswerKeys = Object.keys(pastAnswers);
	let answerKeys = Object.values(answers);
	// console.log(answerKeys);
	for (let i = 0; i < answers.length; i++) {
		let singAnw;
		if (typeof answerKeys[i] === "object") {
			singAnw = Object.values(answerKeys[i])[0];
			// console.log(Object.values(answerKeys[i])[0]);
		} else {
			singAnw = answerKeys[i];
			// console.log(answerKeys[i]);
		}
		inPast[i] = pastAnswerKeys.some((el) => singAnw.toLowerCase().includes(el));
	}
	// console.log(inPast);

	// export let prog
	//$: input,
	//console.log('Single: ' + input.toLowerCase().includes(answers[0])), //сингъл
	//console.log('Multiple: ' + answers.some((el) => input.toLowerCase().includes(el))); //мултипъл

	// console.log(pastAnswers);
	//
	function checkAnswer() {
		if (input == "" || input.replace(/\s/g, "") == "") {
			console.warn("don't try empty answers, man!");
			return;
		}
		switch (
			type // single <> multiple <> mc (multiple correct) <> mc-multiple || single <> multiple for a start
		) {
			// SASP SAMP MASP MAMP single Answer multiple Possibilities
			case "qr":
				if (input.toLowerCase().includes(answers[0])) {
					dispatch("message", {
						msg_content: ui.game.riddle.single_message,
						msg_type: "info",
						msg_action: ui.game.riddle.single_action,
					});
					dispatch("solve", {
						address: riddle.address,
						wrongAnswers: wrongAnswers,
					});
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.wrong_action,
					});
					wrongAnswers.push(input);
				}
				break;

			case "qr-multiple": //multiple options for a single correct
				// console.log(answers);
				// console.log(input.toLowerCase());
				// if (answers[1] === input.toLowerCase()) {
				// 	console.log("DAMN");
				// }
				if (answers.some((el) => input.toLowerCase().includes(el))) {
					dispatch("message", {
						msg_content: ui.game.riddle.single_message,
						msg_type: "info",
						msg_action: ui.game.riddle.single_action,
					});

					dispatch("solve", {
						address: riddle.address,
						wrongAnswers: wrongAnswers,
						// isBonus: isBonus,
					});
					// dispatch('solve', {
					//     address: riddle.address,
					//     wrongAnswers: wrongAnswers,
					// });
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.multiple_wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.multiple_wrong_action,
					});
					wrongAnswers.push(input);
				}
				break;

			case "qr-mc": //multiple correct
				if (answers.some((el) => input.toLowerCase().includes(el))) {
					dispatch("checkPartialSolve", { [input]: true }); //NEW JULY25

					if (
						Object.keys(pastAnswers).some((el) =>
							input.toLowerCase().includes(el)
						)
					) {
						dispatch("message", {
							msg_content: ui.game.riddle.multiple_repeat_message,
							msg_type: "error",
							msg_action: ui.game.riddle.multiple_repeat_action,
						});
					} else {
						dispatch("partialSolve", { [input]: true });
					}
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.wrong_action,
					});
				}

				break;

			case "qr-mc-multiple":
				let mc_multiple = answers;

				for (let i = 0; i < mc_multiple.length; i++) {
					if (typeof mc_multiple[i] === "object") {
						inActive[i] = Object.values(mc_multiple[i]).some((el) =>
							input.toLowerCase().includes(el)
						);
					} else {
						inActive[i] = input.toLowerCase().includes(mc_multiple[i]);
					}
				}
				checkMCMultiple(inActive);

				break;

			default:
				alert(
					"How?! You should not be seeing this... Well, looks like one of the elves messed up... Please report to Santa..um..I mean Obelisk at obelisk [at] vutreshenglas.com. Thanks!"
				);
		}
	}

	function checkMCMultiple(data) {
		let index = data.indexOf(true);

		if (index >= 0) {
			if (!inPast[index]) {
				dispatch("partialSolveType2", { inActive });
			} else {
				dispatch("checkPartialSolve", { [input]: true }); //NEW JULY25

				dispatch("message", {
					msg_content: ui.game.riddle.multiple_repeat_message,
					msg_type: "error",
					msg_action: ui.game.riddle.multiple_repeat_action,
				});
			}
		} else {
			dispatch("message", {
				msg_content: ui.game.riddle.wrong_message,
				msg_type: "error",
				msg_action: ui.game.riddle.wrong_action,
			});
		}
	}

	function handleQrRead(e) {
		// console.log(e);
		// console.log(e.detail);
		input = e.detail;
		qr_state = false;
		checkAnswer();
	}

	const handleEnter = (e) => {
		if (e.key === "Enter" || e.keyCode === 13) {
			checkAnswer();
		}
	};
</script>

<!-- <h1>{type}</h1> -->

{#if qr_state}
	<!-- <div
		transition:slide
		class=" bg-green-400 w-full h-full absolute top-0 left-0"
	> -->
	<Qr
		{lang}
		on:state={(e) => (qr_state = e.details)}
		on:qr_read={handleQrRead}
	/>
	<!-- </div> -->
{/if}

<button on:click={() => (qr_state = !qr_state)}>
	<i class="fa-solid fa-qrcode" data-position="left" />{ui.game.qr
		.scan_btn}</button
>
<p class=" text-center opacity-70 m-auto">
	{ui.game.qr.qr_camera_disclaimer}
</p>

<!-- <Messageboard
	{msg_type}
	{msg_content}
	{msg_shown}
	{msg_action}
	{msg_color}
	on:msg={(e) => {
		msg_shown = e.detail;
		// console.log(e.detail);
	}}
/> -->

{#if type === "qr-unlock"}
	<div class="input-row">
		<input
			class="grow"
			type="text"
			name="field"
			id="field"
			placeholder="_"
			bind:value={input}
			on:keyup={handleEnter}
		/>
		<button id="trigger" on:click={checkAnswer}>{ui.game.aside.button}</button>
	</div>
{/if}

<ul id="progress">
	{#if type == "qr-mc"}
		{#each riddle.answers as answer, i}
			{#if Object.keys(pastAnswers).some((el) => answer
					.toLowerCase()
					.includes(el))}
				<li class="correct" title={ui.game.aside.answer_revealed}>
					<i class="fa-solid fa-check" />
				</li>
			{:else}
				<li style="order:2" title={ui.game.aside.answer_hidden}>
					<i class="fa-solid fa-question" />
				</li>
			{/if}
		{/each}
	{/if}
	{#if type == "qr-mc-multiple"}
		{#each riddle.answers as answer, i}
			{#if typeof answer === "object"}
				{#if inPast[i]}
					<li class="correct" title={ui.game.aside.answer_revealed}>
						<i class="fa-solid fa-check" />
					</li>
				{:else}
					<li style="order:2" title={ui.game.aside.answer_hidden}>
						<i class="fa-solid fa-question" />
					</li>
				{/if}
			{:else if Object.keys(pastAnswers).some((el) => answer
					.toLowerCase()
					.includes(el))}
				<li class="correct" title={ui.game.aside.answer_revealed}>
					<i class="fa-solid fa-check" />
				</li>
			{:else}
				<li style="order:2" title={ui.game.aside.answer_hidden}>
					<i class="fa-solid fa-question" />
				</li>
			{/if}
		{/each}
	{/if}
</ul>

<style>
	#progress {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		padding: 10px;
		gap: 10px;
	}
	#progress li {
		border: 2px solid white;
		flex: 1;
		box-shadow: #093a86 5px 5px 0;
		text-align: center;
	}

	#progress li.correct {
		color: white;
		border: 2px solid #51df67;
		background-color: rgb(22 163 74);
	}
	#progress li i {
		line-height: inherit;
	}

	.input-row {
		display: grid;
		grid-template-columns: 1fr max-content;
	}
	@media screen and (max-width: 480px) {
		.input-row {
			grid-template-columns: auto;
		}
	}
</style>
